import { render } from "./FileDropZone.vue?vue&type=template&id=37da3f4e&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&lang=js"
export * from "./FileDropZone.vue?vue&type=script&lang=js"

import "./FileDropZone.vue?vue&type=style&index=0&id=37da3f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37da3f4e"]])

export default __exports__